import { wordService } from "./wordService";

export class NumberingService {
  // Caption-based numbering lives in wordService (it inserts/relabels caption
  // content controls). These wrappers keep the existing button API.
  async autoNumberFigures(): Promise<number> {
    return (await wordService.numberFiguresAndTables()).figures;
  }

  async autoNumberTables(): Promise<number> {
    return (await wordService.numberFiguresAndTables()).tables;
  }

  async generateToc(): Promise<void> {
    await wordService.generateTableOfContents();
  }
}

export const numberingService = new NumberingService();
